module.exports = __webpack_public_path__ + "static/img/4.97c5cce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/4.jpg
// module id = PMx2
// module chunks = 1